import { render } from "./AccountSupportModal.vue?vue&type=template&id=4e8cf487"
import script from "./AccountSupportModal.vue?vue&type=script&lang=ts"
export * from "./AccountSupportModal.vue?vue&type=script&lang=ts"
script.render = render

export default script